import { setFormById, setFormData, setFieldValue } from '../actions/forms';
import { SELL_TICKET_FORM } from '../reducers/features';

export const decoratePayloadSelectedTickets = (tickets) => {
    const selectedTickets = tickets.filter((ticket) => ticket.isSelected);
    return selectedTickets.map((ticket) => ticket.code);
};

export const decoratePayloadSellPriceTickets = (tickets) => Object.keys(tickets)
    .map((key) => ({
        code: key,
        sellPrice: tickets[key].sellPrice,
    }));

export const populateFormTickets = ({ tickets }, dispatch) => {
    const formTickets = [];
    tickets.forEach((ticket) => {
        formTickets[`${ticket.code}`] = {
            sellPrice: ticket.sellPrice,
            isValid: true,
            errorMessage: null,
        };
    });
    dispatch(setFormData(SELL_TICKET_FORM, formTickets));
};

export const populateFormErrors = ({ errors }, dispatch) => {
    if (!errors) {
        return;
    }
    errors.forEach((error) => {
        dispatch(setFormById(SELL_TICKET_FORM, error.ticketId, {
            errorMessage: error.message,
            isValid: false,
        }));
    });
};
export const populateFields = (form, data, dispatch) => {
    Object.keys(data)
        .forEach((field) => {
            dispatch(setFieldValue(form, field, data[field]));
        });
};
export const decoratePayload = (inputs) => Object.keys(inputs)
    .reduce((acc, key) => {
        if (inputs[key].isVisible === false) {
            return acc;
        }
        acc[key] = inputs[key].value;
        return acc;
    }, {});
